/** All tunable numbers in one place. */
export const SCORING = {
  pointsFirstTry: 2,
  pointsAfterRetry: 1,
  pointsExerciseComplete: 5,
  pointsPerfectBonus: 10,
  pointsMistakesRetried: 5,
  starsThreeAt: 0.9,
  starsTwoAt: 0.7,
  defaultDailyStarGoal: 20,
  leaderboardDailyStarCap: 60,
} as const;

export const MASTERY = {
  masteredRead: 80,
  masteredListen: 80,
  masteredWrite: 70,
  /** SRS intervals in days, chosen by score band. */
  intervalsByScore: [
    { below: 40, days: 1 },
    { below: 60, days: 3 },
    { below: 80, days: 7 },
    { below: 90, days: 14 },
    { below: 101, days: 30 },
  ],
  failureIntervalDays: 1,
} as const;

export const SESSION = {
  setSize: 5,
  practiceQuestions: 10,
  reviewQuestions: 10,
  /** Test questions per character: a set test asks twice per character, a lesson test once. */
  testPerCharacterSet: 2,
  testPerCharacterLesson: 1,
  /** choices shown by exposure count: first time 2, then 3, review 4 */
  choicesFirst: 2,
  choicesLater: 3,
  choicesReview: 4,
} as const;

/** The daily challenge (`dailyChallenge.ts`): a short mixed-pool test over every character the
 * child has attempted at least once, drawn across lessons rather than one set or lesson. */
export const DAILY_CHALLENGE = {
  questions: 10,
} as const;

/** The island Challenge on the adventure path: longer and stricter than any other stop. */
export const CHALLENGE = {
  /** Share of the questions that are the island's own set when a caller passes earlier material
   * to reach back into (the app currently passes none, so the Challenge is the set alone). */
  setShare: 0.6,
  /** Questions in the island Challenge (a short boss round, `buildIslandChallenge`); a set with
   * more characters than this asks each once. The mixed `buildChallenge` ignores it. */
  islandQuestions: 8,
  /** Never shorter than this, even on the first island where there is nothing earlier to draw from. */
  minQuestions: 15,
  /** First-try score needed to open the gate. */
  passRatio: 0.7,
} as const;

/** The spec's mixed-review recipe (must sum to reviewQuestions). */
export const REVIEW_MIX = {
  audio_to_picture: 2,
  picture_to_hanzi: 1,
  match_pairs: 1,
  audio_to_hanzi: 1,
  pinyin_to_hanzi: 1,
  tone: 1,
  speak: 1,
  sentence_fill: 1,
  trace: 1,
} as const;
